import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

interface CreateServicePlanInput {
  name: string;
  description: string;
  indicater: string;
  noOfDays: number;
}
export async function createServicePlan(input: CreateServicePlanInput) {
  let data;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
        mutation createServicePlan (
          $input:CreateServicePlanInput!
        ) {
          createServicePlan(
            createServicePlanInput:$input
          )
        }
      `,
      variables: {
        input,
      },
    },
  }).catch((e: any) => (data = e.response));
  return data;
}

export async function updateServicePlans(input: CreateServicePlanInput, id: string) {
  let data: any;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
        mutation updateServicePlan (
          $id: String!
          $input: CreateServicePlanInput!
        ) {
          updateServicePlan(
            createServicePlanInput: $input
            id: $id
          )
        }
      `,
      variables: { id, input },
    },
  }).catch((e: any) => (data = e.response));
  return data;
}


export async function getServicePlans(
  where: {} = {},
  pagination: {} | undefined = undefined
) {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
                  query getServicePlans(
                    $where: ServicePlansResolver_GetServicePlans_FilterInputType,
                    $paginate: PaginatorArgs
                    ) {
                      getServicePlans (where:$where, paginate: $paginate) {
                        data {
                            id
                            name
                            description
                            indicater
                            noOfDays
                            createdAt
                        }
                        totalPages
                        total
                        perPage
                        page
                      }
                  }
                  `,
      variables: { where, paginate: pagination },
    },
  });
  return data?.data?.data?.getServicePlans;
}
export async function getServicePlanList() {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
                  query {
                     getServicePlanList {
                        id
                        name
                        description
                        indicater
                        noOfDays
                    }
                  }
                  `,
      variables: {},
    },
  });
  return data?.data?.data?.getServicePlanList;
}